'use client';
import React from 'react';

import {
  BundleProduct,
  GetCartItemsQuery,
  GetCustomerCartQuery,
} from '@storefront/data-commerce';
import useInsideData from '@storefront/hooks/useInsideData';
import { InsideOrderData } from '@storefront/types/insideData.d';

interface InsideData {
  cart?: GetCustomerCartQuery['customerCart'] | GetCartItemsQuery['cart'];
  insideOrderData?: InsideOrderData;
  page: { name: string; type: string };
  product?: BundleProduct;
}

export default function InsideData(props: Readonly<InsideData>) {
  const { cart, insideOrderData, page, product } = props;
  useInsideData({
    page: { name: page.name, type: page.type },
    cart: cart,
    order: insideOrderData,
    product: product,
  });

  return <></>;
}
